/**
 * Builds OneSignal tags from conference data
 * API: { id, name, type, year, currentConference }
 * - Tags GIC if the user has any conference with type "GIC"
 * - Tags currentConference "<type>_<year>_<id>" (e.g. "gic_2026_5") for the conference flagged
 *   currentConference, since type+year alone isn't unique (multiple GIC conferences can share a year).
 *   Empty string when no conference is flagged current, so a stale value never lingers.
 *
 * One tag, so several conferences flagged current still resolve to a single
 * value (highest id — see getCurrentConference). If a delegate live in two
 * conferences ever needs pushes for BOTH, this tag scheme can't express that
 * and would need rethinking.
 */
import { getCurrentConference } from '@/utils/conference-type';

export function buildConferenceTags(conferences) {
  const tags = {};

  const gic = conferences.find(conf => conf.type === 'GIC');
  if (gic) {
    tags['GIC'] = 'true';
  }

  const current = getCurrentConference(conferences);
  tags['currentConference'] = current
    ? `${current.type}_${current.year}_${current.id}`.toLowerCase()
    : '';

  return tags;
}
